<div >
  <h4 class="m-t-0" mat-dialog-title>{{'deleteClientLabel' | translate}}
  </h4>
  <p>{{'sureYouWantToDeleteStart' | translate}} Volksbank Musterstadt {{'sureYouWantToDeleteEnd' | translate}}?</p>
  <span class="m-l-130">
    <button mat-raised-button color="basic" (click)="closeDialog()">{{'stop' | translate}}</button>
    <button mat-raised-button cdkFocusInitial class="custom-button m-l-10" (click)="deleteMandaten()">{{'deleteCap' | translate}}</button>
  </span>
</div>